import { render, staticRenderFns } from "./media_flow_allocate_list.vue?vue&type=template&id=04c393dc&scoped=true&"
import script from "./media_flow_allocate_list.vue?vue&type=script&lang=js&"
export * from "./media_flow_allocate_list.vue?vue&type=script&lang=js&"
import style0 from "./media_flow_allocate_list.vue?vue&type=style&index=0&id=04c393dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c393dc",
  null
  
)

export default component.exports